import { z } from "zod";

export const paginationSchema = z.object({
  count: z.number(),
  total: z.number(),
  perPage: z.number(),
  currentPage: z.number(),
  totalPages: z.number(),
  links: z.object({
    previous: z.string().optional(),
    next: z.string().optional(),
  }),
});

export const createServiceResponseSchema = <T extends z.ZodTypeAny>(
  dataSchema: T,
) => {
  return z.object({
    status: z.number(),
    success: z.boolean(),
    data: dataSchema,
    pagination: paginationSchema.optional(),
  });
};
